import { Dispatch } from 'redux';
import { ChatAssistantResponse } from '../../models/responses/ChatAssistantResponse';
import { SessionTitleRequest } from "../../models/requests/SessionTitleRequest";
import { getUserChatHistoryBySessionId } from '../../api/assistantApi';
import { generateSessionTitle, updateUserSession } from "../../api/userSessionApi";
import { UserSessionRequest } from "../../models/requests/UserSessionRequest";


export const CHAT_WITH_ASSISTANT_SUCCESS = 'CHAT_WITH_ASSISTANT_SUCCESS';
export const CHAT_WITH_ASSISTANT_ERROR = 'CHAT_WITH_ASSISTANT_ERROR';

export const LOAD_USER_CONVERSATIONS_SUCCESS = 'LOAD_USER_CONVERSATIONS_SUCCESS';
export const LOAD_USER_CONVERSATIONS_ERROR = 'LOAD_USER_CONVERSATIONS_ERROR';

export const LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_SUCCESS = 'LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_SUCCESS';
export const LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_ERROR = 'LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_ERROR';

export const CLEAR_USER_CONVERSATIONS = 'CLEAR_USER_CONVERSATIONS';

export const SESSION_TITLE_UPDATED_SUCCESS = 'SESSION_TITLE_UPDATED_SUCCESS';

export const ConversationCount = 20;


export function chatWithAssistantSuccess(payload: ChatAssistantResponse) {
    return { type: CHAT_WITH_ASSISTANT_SUCCESS, payload: payload };
}

export function chatWithAssistantError(error: any) {
    return { type: CHAT_WITH_ASSISTANT_ERROR, payload: error };
}

// load user chat history by session id

export function loadUserChatHistoryBySessionIdSuccess(payload: ChatAssistantResponse) {
    return { type: LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_SUCCESS, payload: payload };
}

export function loadUserChatHistoryBySessionIdError(error: any) {
    return { type: LOAD_USER_CHAT_HISTORY_BY_SESSION_ID_ERROR, payload: error };
}

export function clearUserConversations() {
    return { type: CLEAR_USER_CONVERSATIONS };
}

export function loadUserChatHistoryBySessionId(sessionId: string) {
    return async (dispatch: Dispatch<any>) => {
        try {
            // Clear existing conversations before loading new ones
            dispatch(clearUserConversations());
            const response = await getUserChatHistoryBySessionId(sessionId);
            dispatch(loadUserChatHistoryBySessionIdSuccess(response));
        } catch (error) {
            dispatch(loadUserChatHistoryBySessionIdError(error));
        }
    }
}

export function updateUserConversation(answerResponse: ChatAssistantResponse) {
    return async (dispatch: Dispatch<any>) => {
        try {
            const existingMessages = JSON.parse(localStorage.getItem('_chatMessages_') || '[]');
            const currentConversationMessages = existingMessages || [];
            const nextOrderIndex = currentConversationMessages.length + 1;

            answerResponse.OrderIndex = nextOrderIndex;

            const plainObjectResponse = {
                Question: answerResponse.Question,
                Answer: answerResponse.Answer,
                OrderIndex: answerResponse.OrderIndex,
                ChatGptAnswer: answerResponse.ChatGptAnswer,
            };

            persistToLocalStorage(plainObjectResponse);
            dispatch(chatWithAssistantSuccess(plainObjectResponse));

            return plainObjectResponse;
        } catch (error) {
            dispatch(chatWithAssistantError(error));
        }
    };
}

const persistToLocalStorage = (newMessage: any) => {
    const existingMessages = JSON.parse(localStorage.getItem('_chatMessages_') || '[]');
    let updatedMessages = [...existingMessages, newMessage];
    if (updatedMessages?.length >= ConversationCount)
        updatedMessages = updatedMessages.slice(-ConversationCount);

    localStorage.setItem('_chatMessages_', JSON.stringify(updatedMessages));
};


export function loadUserConversationsSuccess(userConversations: any) {
    return { type: LOAD_USER_CONVERSATIONS_SUCCESS, payload: userConversations };
}

export function loadUserConversationsError(error: any) {
    return { type: LOAD_USER_CONVERSATIONS_ERROR, payload: error };
}

const generatedTitleSessions = new Set<string>();

export const generateAndUpdateSessionTitle = (
    sessionId: string,
    firstMessage: ChatAssistantResponse,
    userEmail: string,
    collectionId?: number | null
) => {
    return async (dispatch: Dispatch) => {
        if (generatedTitleSessions.has(sessionId)) {
            return;
        }

        generatedTitleSessions.add(sessionId);

        try {
            const firstInteraction = `User: ${firstMessage.Question}\nAssistant: ${firstMessage.Answer}`;
            const sessionTitleRequest = new SessionTitleRequest(firstInteraction, sessionId);
            const response = await generateSessionTitle(sessionTitleRequest);

            if (response?.data?.result) {
                const generatedTitle = response.data.result;
                const updateRequest = new UserSessionRequest(generatedTitle, userEmail, sessionId, collectionId);

                const updateResponse = await updateUserSession(updateRequest);

                if (updateResponse?.data) {
                    dispatch({
                        type: SESSION_TITLE_UPDATED_SUCCESS,
                        payload: { sessionId, title: generatedTitle }
                    });
                } else {
                    generatedTitleSessions.delete(sessionId);
                }
            } else {
                const fallbackTitle = `Chat: ${firstMessage.Question.substring(0, 40)}${firstMessage.Question.length > 40 ? '...' : ''}`;
                const updateRequest = new UserSessionRequest(fallbackTitle, userEmail, sessionId);
                const updateResponse = await updateUserSession(updateRequest);

                if (updateResponse?.data) {
                    dispatch({
                        type: SESSION_TITLE_UPDATED_SUCCESS,
                        payload: { sessionId, title: fallbackTitle }
                    });
                }
            }
        } catch (error) {
            generatedTitleSessions.delete(sessionId);

            try {
                const fallbackTitle = `Chat: ${firstMessage.Question.substring(0, 40)}${firstMessage.Question.length > 40 ? '...' : ''}`;

                const updateRequest = new UserSessionRequest(fallbackTitle, userEmail, sessionId);
                const updateResponse = await updateUserSession(updateRequest);

                if (updateResponse?.data) {
                    generatedTitleSessions.add(sessionId);
                    dispatch({
                        type: SESSION_TITLE_UPDATED_SUCCESS,
                        payload: { sessionId, title: fallbackTitle }
                    });
                }
            } catch (fallbackError) {
                console.error('Background: Even fallback title update failed:', fallbackError);
            }
        }
    };
};